import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useWorkerWorkBadgesMaxUi() {
  return useCbhFlag(CbhFeatureFlag.RELEASE_WORKER_WORK_BADGES_MAX_UI, {
    defaultValue: { enabled: false },
  });
}
